/* RESPONSIBLE TEAM: team-ml */
import { buildValidations, validator } from 'ember-cp-validations';
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

const Validations = buildValidations({
  emailSetupValid: [
    validator('ai-agent-email-setup-valid', {
      dependentKeys: ['app.dkim_settings.[]', 'app.customEmailAddresses.[]'],
    }),
  ],
});

export default class SdrFollowupEmail extends Step.extend(Validations) {
  get app() {
    return this.appService.app;
  }

  get supportedChannels() {
    return SUPPORTED_CHANNELS.sdrFollowupEmail;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation];
  }

  static get requiredBillingFeature() {
    return null;
  }

  static createNewStep(store: Store): SdrFollowupEmail {
    return store.createRecord('operator/visual-builder/step/sdr-followup-email', {
      type: 'operator/visual-builder/step/sdr-followup-email',
    });
  }
}
